export const hasValue = (value) => {
  return typeof value !== 'undefined' && value !== null;
};

export const hasDate = (value) => {
  return hasValue(value) && typeof value === 'object' && value._isAMomentObject;
};
